import React from 'react';
import { Card, CardBody } from 'reactstrap';
// import EditManagedProductForm from '../EditManagedProductForm';
// import ConfirmModal from 'js/components/modal/ConfirmModal';

function ManagedProductOverview({ managedProduct, onUpdate }) {
  // const [showArchiveModal, setShowArchiveModal] = useState(false);

  // const handleUpdate = useCallback(
  //   (values) => {
  //     return onUpdate({ id: managedProduct.id, ...values });
  //   },
  //   [managedProduct?.id, onUpdate]
  // );

  // const handleArchive = () => {
  //   setShowArchiveModal(true);
  // };

  // const handleUnarchive = useCallback(() => {
  //   return onUpdate({ id: managedProduct.id, archived_state: null });
  // }, [managedProduct?.id, onUpdate]);

  // const handleArchiveModalConfirm = useCallback(async () => {
  //   await onUpdate({
  //     id: managedProduct.id,
  //     archived_state: 'archived',
  //   });
  //   setShowArchiveModal(false);
  // }, [managedProduct?.id, onUpdate]);

  return !managedProduct ? null : (
    <>
      <Card>
        <CardBody>
          {/* <EditManagedProductForm
            managedProduct={managedProduct}
            onSubmit={handleUpdate}
            onArchive={handleArchive}
            onUnarchive={handleUnarchive}
          /> */}
        </CardBody>
      </Card>
    </>
  );
}

export default ManagedProductOverview;
